export default __webpack_public_path__ + "static/media/Group 1284Yono.c2015119.png";